import { h } from 'preact'

export const OffresComplementaires = ({ title, items, cacheKey }) => {
   return (
      <div class="offres-complementaires container-fluid mt-2 mt-xl-3" data-cache-key={cacheKey}>
         <div class="row">
            <div class="col-12">
               <h2 class="title no-signature">{title}</h2>
            </div>
            <div class="col-12">
               <ul class="row mb-0 list-unstyled">
                  {items.map((offre) => (
                     <Offre {...offre} />
                  ))}
               </ul>
            </div>
         </div>
      </div>
   )
}

const Offre = ({ background_color, title, image, alt, CTA: { label, URL, analytics } }) => {
   return (
      <li class="col-12 col-md-6">
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            class={`offre ${background_color === 'black' ? 'bg-dark' : ''}`}
         >
            <div class="offre-content">
               <div class="offre-title-wrapper">
                  <h3 class={`offre-title h4 ${background_color === 'black' ? 'text-white' : 'text-dark'}`}>{title}</h3>
               </div>
               <span class={`btn btn-primary ${background_color === 'black' ? 'btn-inverse' : ''}`}>{label}</span>
            </div>
            <div class="offre-image">
               <img src={`${image}?saveas=webp`} alt={alt || ''} loading="lazy" />
            </div>
         </a>
      </li>
   )
}
